<div class="row">
  <div class="col-md-12">
    <table class="table table-light mb-0">
      <thead>
      <tr>
        <th scope="col" class="col-md-2">{{ 'pages.decision.model.channel' | translate }}</th>
        <th scope="col" class="col-md-2">{{ 'pages.decision.model.core' | translate }}</th>
        <th scope="col" class="col-md-2">{{ 'pages.decision.model.created' | translate }}</th>
        <th scope="col" class="col-md-2">{{ 'pages.decision.model.updated' | translate }}</th>
        <th scope="col" class="col-md-1">{{ 'pages.decision.model.status' | translate }}</th>
        <th scope="col" class="col-md-1"></th>
      </tr>
      </thead>
      <tbody class="table-group-divider">
      <tr>
        <td style="font-weight: 500">{{ model?.channel?.owner }} / {{ model?.channel?.vertical }}
          / {{ model?.channel?.code }}</td>
        <td class="fw-bolder">{{ model?.algorithm }}</td>
        <td>{{ getCreatedAsDate() }}</td>
        <td>{{ getUpdatedAsDate() }}</td>
        <td [ngClass]="{'text-info fw-bolder': model?.status == 'READY', 'text-success warning': model?.status == 'NEW', 'text-warning fw-bolder': model?.status == 'LEARNING', 'text-error': model?.status == 'ERROR'}">{{ model?.status }}</td>
        <td>
          <div class="dropdown text-end">
            <a class="btn btn-primary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              actions
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" (click)="feedback(model!.channel)">feedback</a></li>
              <li><a class="dropdown-item" (click)="learn(model!.channel)">learn</a></li>
              <li><a class="dropdown-item" (click)="predict(model!.channel)">predict</a></li>
            </ul>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row" [hidden]="model === undefined || model.status === 'NEW'">
  <div class="col-md-12">
    <div class="pt-2">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
          <button ngbNavLink>Data</button>
          <ng-template ngbNavContent>
            <admin-decisions-model-data [channel]="channel"/>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <button ngbNavLink>Evolution</button>
          <ng-template ngbNavContent>
            <admin-decisions-model-evolution [channel]="channel"/>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <button ngbNavLink>Expectation</button>
          <ng-template ngbNavContent>
            <admin-decisions-model-expectation [channel]="channel"/>
          </ng-template>
        </li>
      </ul>

      <div class="tab-content bg-white p-2" id="myTabContent">
        <div class="tab-pane fade show active" id="one" role="tabpanel">
          <div [ngbNavOutlet]="nav"></div>
        </div>
      </div>
    </div>

  </div>
</div>
